import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {publicUrl} from '../Api';

export default class DemoViewer extends Component {
    static propTypes = {
        srcPrefix: PropTypes.string,
        imageInfo: PropTypes.shape({
            src: PropTypes.string,
            poppedSrc: PropTypes.string,
        }),
        onError: PropTypes.func,
        isOriginalActive: PropTypes.bool,
    };

    static defaultProps = {
        srcPrefix: publicUrl,
    };

    render() {
        const {srcPrefix, imageInfo, onError, isOriginalActive} = this.props;
        const {poppedSrc, src} = imageInfo;
        return (
            <div className="demo-image">
                <img
                    src={(srcPrefix || '') + src}
                    style={{display: (isOriginalActive ? 'block' : 'none')}}
                    className="galleryPic"
                    crossOrigin="use-credentials"
                    onError={() => onError(src)}
                    alt="original"
                />
                <img
                    src={(srcPrefix || '') + poppedSrc}
                    style={{display: (!isOriginalActive ? 'block' : 'none')}}
                    className="galleryPic"
                    crossOrigin="use-credentials"
                    onError={() => onError(poppedSrc)}
                    alt="popped"
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/DemoViewer.js